<script setup>
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

const route = useRoute()
if (!isValidPastUrl(route.params.year, route.params.month, route.params.day)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
useCustomMeta('chartDay', `${route.params.year}年`, `${Number(route.params.month)}月`, `${Number(route.params.day)}日`, `/chart/${route.params.year}/${route.params.month}/${route.params.day}/`)
const breadCrumbList = getBreadCrumb('chart', 'day', route.params.year, route.params.month, route.params.day)
const time = dayjs.utc(`${route.params.year}${route.params.month}${route.params.day}`, 'YYYYMMDD').unix()
const { data: chartList } = await useFetch('/api/past/chart/list', { query: { time: time } })
const { data: comment } = await useFetch('/api/past/chart/comment', { query: { time: time } })
</script>
<template>
  <div>
    <NuxtLayout
      name="chart"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <PastChartImgViewer
          :img-list="chartList"
          :basetime="time"
        />
      </div>
      <template #main-bottom>
        <div
          v-if="comment"
          class="info"
        >
          <PastChartComment
            :title="comment.title"
            :body="comment.body"
          />
        </div>
      </template>
    </NuxtLayout>
  </div>
</template>
<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
